<template>
	<div class="experience-edit-elements">
		<ModalHeader :title="getString('set_elements')" :button-text="getString('save')" @click-button="saveElements" />
		<div class="availability-container">
			<div class="container-quantities available-container">
				<p class="subtitle">{{ getString('quantities_available') }}</p>
				<div class="table-container">
					<div class="elements-row">
						<div class="icon-section" v-html="getIcon('iconAnalyticsTable')"></div>
						<div class="value-section">{{ totals.tables }}</div>
					</div>
					<div class="people-row">
						<div class="icon-section" v-html="getIcon('iconPerson')"></div>
						<div class="value-section">{{ totals.people }}</div>
					</div>
				</div>
			</div>
			<div class="container-quantities selected-container">
				<p class="subtitle">{{ getString('total_selected') }}</p>
				<div class="table-container">
					<div class="elements-row">
						<div class="icon-section" v-html="getIcon('iconAnalyticsTable')"></div>
						<div class="value-section">{{ totals.selectedTables }}</div>
					</div>
					<div class="people-row">
						<div class="icon-section" v-html="getIcon('iconPerson')"></div>
						<div class="value-section">{{ totals.selectedPeople }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tables-list-container">
			<div class="rooms">
				<div class="room" v-for="room in roomsStore.roomsTables" :key="room.room_id">
					<div class="room-header" @click="toggleRoom(room)">
						<div class="left-side">
							<div class="checkbox-container" @click.stop="checkRoom(room)">
								<AppCheckbox :auto-toggle="false" :is-active="isRoomActive(room)" />
							</div>
							<p>{{ room.name }}</p>
						</div>
						<div class="right-side">
							<div class="info-container-wrapper">
								<div class="info-container">
									<div class="icon-container" v-html="getIcon('iconAnalyticsTable')"></div>
									<div class="value">{{ room.tables.length }}</div>
								</div>
								<div class="info-container">
									<div class="icon-container" v-html="getIcon('iconPerson')"></div>
									<div class="value">{{ room.tables.reduce((acc, table) => acc + (table.seat_number || 0), 0) }}</div>
								</div>
							</div>
							<div class="arrow-container">
								<AppChevronIcon :direction="room.active ? 'up' : 'down'" />
							</div>
						</div>
					</div>
					<div class="room-body">
						<AppDropdown :collapsed="!room.active" square-corner>
							<div class="room-dropdown">
								<div class="tables-container">
									<div class="table" v-for="table in room.tables" :key="table.room_table_id">
										<div class="table-header"  @click="checkTable(table)">
											<div class="left-side">
												<div class="checkbox-container">
													<AppCheckbox :auto-toggle="false" :is-active="isTableActive(table)" />
												</div>
												<p>{{ table.table_name }}</p>
											</div>
											<div class="right-side">
												<div class="value">{{ (table.seat_number || 0) }}</div>
												<div class="icon-container" v-html="getIcon('iconPerson')"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</AppDropdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {useExperiencesStore, useRoomsStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import AppCheckbox from "@/shared/components/AppCheckbox.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";

export default {
	components: {ModalHeader, AppDropdown, AppChevronIcon, AppCheckbox},
	setup() {
		const experiencesStore = useExperiencesStore();
		const userStore = useUserStore();
		const svgStore = useSvgStore();
		const roomsStore = useRoomsStore();
		return {getString: useLanguageStore().getString, experiencesStore, userStore, getIcon: svgStore.get, roomsStore};
	},
	name: "ExperienceEditElements",
	props: {
		experienceId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			selected: {}
		}
	},
	computed: {
		experience() {
			return this.experiencesStore.businessExperiences.find(experience => experience.experience_id === this.experienceId);
		},
		totals() {

			let totals = {
				tables: 0,
				people: 0,
				selectedTables: 0,
				selectedPeople: 0
			};

			this.roomsStore.roomsTables.forEach(room => {
				room.tables.forEach(table => {
					totals.tables += 1;
					totals.people += (table.seat_number || 0);

					if(this.selected[table.room_table_id]) {
						totals.selectedTables += 1;
						totals.selectedPeople += (table.seat_number || 0);
					}
				});
			});

			return totals;

		}
	},
	methods: {
		toggleRoom(room) {
			this.roomsStore.roomsTables.forEach(r => {
				if(r.room_id !== room.room_id) {
					r.active = false;
				}
			});
			room.active = !room.active;
		},
		isRoomActive(room) {
			return room.tables.every(table => this.selected[table.room_table_id]);
		},
		isTableActive(table) {
			return this.selected[table.room_table_id];
		},
		checkRoom(room) {
			let v = !this.isRoomActive(room);
			if(v) {
				room.tables.forEach(table => {
					if(!this.selected[table.room_table_id]) {
						this.selected[table.room_table_id] = true;
					}
				});
			} else {
				room.tables.forEach(table => {
					if(this.selected[table.room_table_id]) {
						this.selected[table.room_table_id] = false;
					}
				});
			}
		},
		checkTable(table) {
			this.selected[table.room_table_id] = !this.selected[table.room_table_id];
		},
		saveElements() {
			let selected = [];
			Object.keys(this.selected).forEach(key => {
				if(this.selected[key]) {
					selected.push(key);
				}
			});
			this.experiencesStore.saveExperienceTables(this.experienceId, selected, (r) => {
				if(r) {
					this.experience.tables = selected.map(tableId => {
						return {
							room_table_id: Number(tableId),
							experience_id: this.experienceId
						}
					});
					this.experiencesStore.editElementsId = null;
				}
			});
		},
		initSelected() {
			this.selected = {};
			this.experience.tables.forEach(table => {
				this.selected[table.room_table_id] = true;
			});
		}
	},
	mounted() {
		this.initSelected();
	},
}
</script>

<style scoped lang="scss">
.availability-container {
	display: flex;
	gap: 20px;

	@media (max-width: 550px) {
		flex-direction: column;
	}

	.container-quantities {
		flex: 1;

		.subtitle {
			font-size: 16px;
			margin-bottom: 10px;
			margin-left: 44px;
		}

		.table-container {
			display: flex;
			flex-direction: column;
			border-radius: 13px;
			box-shadow: inset 0 2px 4px 0 $alpha_4;
			overflow: hidden;

			.elements-row {
				border-bottom: 1px solid $primary;
			}

			.elements-row, .people-row {
				display: flex;

				.icon-section {
					width: 44px;
					height: 44px;
					background-color: var(--color-alpha-1);
					display: flex;
					align-items: center;
					justify-content: center;

					&:deep(svg) {
						width: 16px;
						height: 16px;

						.fill {
							fill: var(--color-txt);
						}

						.stroke {
							stroke: var(--color-txt);
						}
					}
				}

				.value-section {
					flex: 1;
					background-color: var(--color-alpha-2);
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 24px;
				}
			}

		}

		&.selected-container {
			.table-container {
				.elements-row, .people-row {
					.icon-section {
						background-color: var(--color-alpha-1);
					}
					.value-section {
						background-color: var(--color-alpha-3);
					}
				}
			}
		}
	}
}
.tables-list-container {
	padding: 4px;
	padding-top: 10px;
	.rooms {
		display: flex;
		flex-direction: column;
		border-radius: 13px;
		box-shadow: 0 1px 2px $alpha;
		overflow: hidden;

		.room {
			width: 100%;
			border-bottom: 1px solid $alpha;

			&:last-child {
				border-bottom: none;
			}


			.room-header {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;
				background-color: var(--color-bg);

				.left-side {
					display: flex;
					align-items: center;
					justify-items: flex-start;
					gap: 10px;
					flex-grow: 1;

					.checkbox-container {
						width: 30px;
						height: 44px;
					}

					.label-container {
						width: 100%;
						height: 100%;
					}
					p {
						font-size: 16px;
						max-width: 350px;
						line-height: 18px;
						@include truncateString(2);

						@media (max-width: 768px) {
							max-width: 200px;
						}
					}
				}

				.right-side {
					display: flex;
					align-items: stretch;
					gap: 12px;
					flex-shrink: 0;

					.info-container-wrapper {
						display: flex;
						gap: 4px;
						justify-content: flex-end;
						align-items: center;

						@media (max-width: 500px) {
							flex-direction: column;
							justify-content: center;
							padding: 4px 0;
						}
					}

					.info-container {
						display: flex;
						align-items: center;
						gap: 8px;
						background-color: $alpha_2;
						border-radius: 13px;
						padding: 6px 8px;
						min-width: 66px;
						box-shadow: inset 0 1px 2px $alpha;


						.icon-container {
							display: flex;
							align-items: center;
							justify-content: center;

							&:deep(svg) {
								width: 16px;
								height: 16px;

								.fill {
									fill: var(--color-txt);
								}

								.stroke {
									stroke: var(--color-txt);
								}
							}
						}

						.value {
							font-size: 16px;
						}
					}

					.arrow-container {
						width: 30px;
						min-height: 44px;
						background-color: $alpha_2;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}

			}

			.room-body {
				:deep(.dropdown-content) {
					margin-top: 0;
				}
				
				.room-dropdown {
					
					.tables-container {
						display: flex;
						flex-direction: column;
						border-radius: 13px;
						box-shadow: 0 1px 2px $alpha;
						overflow: hidden;
						
						.table {
							width: 100%;
							border-bottom: 1px solid $alpha;
							background-color: var(--color-bg-primary-1);
							
							&:last-child {
								border-bottom: none;
							}
							
							.table-header {
								width: 100%;
								display: flex;
								justify-content: space-between;
								align-items: center;
								padding: 0;
								cursor: pointer;
								
								.left-side {
									display: flex;
									align-items: center;
									justify-items: flex-start;
									gap: 10px;
									flex-grow: 1;

									.checkbox-container {
										width: 30px;
										height: 44px;
									}

									.label-container {
										width: 100%;
										height: 100%;
									}
									p {
										font-size: 14px;
									}
								}
								
								.right-side {
									display: flex;
									align-items: center;
									gap: 8px;
									flex-shrink: 0;
									padding-right: 12px;

									.icon-container {
										display: flex;
										align-items: center;
										justify-content: center;

										&:deep(svg) {
											width: 14px;
											height: 14px;
											.fill {
												fill: var(--color-txt);
											}

											.stroke {
												stroke: var(--color-txt);
											}
										}
									}

									.value {
										font-size: 14px;
										text-align: right;
									}

								}
								
							}
						}
					}
				}
			}
		}
	}
}
</style>